import { render } from "./PendingItem.vue?vue&type=template&id=c55a64ee&scoped=true&ts=true"
import script from "./PendingItem.vue?vue&type=script&lang=ts"
export * from "./PendingItem.vue?vue&type=script&lang=ts"

import "./PendingItem.vue?vue&type=style&index=0&id=c55a64ee&scoped=true&lang=css"

import exportComponent from "/builds/custom-client/enablewa-token-refresher/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55a64ee"]])

export default __exports__